export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: string;
}

export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  delta: string;
  up: boolean;
}

export interface EventItem {
  id: string;
  title: string;
  category: string;
  categoryId: string;
  excerpt: string;
  image: string;
  views: string;
  comments: string;
  time: string;
  heat: number;
  trending: boolean;
}

export interface GuideItem {
  icon: string;
  title: string;
  desc: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface ReviewItem {
  name: string;
  role: string;
  text: string;
  avatar: string;
}

export const categories: Category[] = [
  { id: 'ent', name: '明星娱乐', icon: 'ri-star-smile-fill', desc: '圈内动态一手掌握', count: '328条现场' },
  { id: 'society', name: '社会热点', icon: 'ri-community-fill', desc: '身边新闻第一现场', count: '256条现场' },
  { id: 'tech', name: '科技圈', icon: 'ri-rocket-fill', desc: '数码互联网趣闻', count: '189条现场' },
  { id: 'film', name: '影视综艺', icon: 'ri-film-fill', desc: '剧综花絮抢先看', count: '172条现场' },
  { id: 'business', name: '商业财经', icon: 'ri-line-chart-fill', desc: '大佬动向深度解读', count: '146条现场' },
  { id: 'sports', name: '体坛赛事', icon: 'ri-trophy-fill', desc: '赛场内外热血瞬间', count: '121条现场' },
];

export const hotList: HotItem[] = [
  { rank: 1, title: '某综艺录制现场突发状况引热议', tag: '爆', heat: 982, delta: '↑ 1.2万', up: true },
  { rank: 2, title: '知名主播凌晨直播间回应质疑', tag: '热', heat: 915, delta: '↑ 8900', up: true },
  { rank: 3, title: '顶流新剧首播预告细节被扒', tag: '新', heat: 868, delta: '↓ 3200', up: false },
  { rank: 4, title: '科技公司发布会官宣重磅新品', tag: '热', heat: 801, delta: '↑ 6800', up: true },
  { rank: 5, title: '网友偶遇明星深夜现身街角咖啡店', tag: '瓜', heat: 754, delta: '↑ 5100', up: true },
  { rank: 6, title: '体育赛事决赛名场面全网刷屏', tag: '燃', heat: 702, delta: '↓ 1200', up: false },
  { rank: 7, title: '某品牌回应争议网友两极分化', tag: '热', heat: 655, delta: '↑ 4300', up: true },
  { rank: 8, title: '素人神曲翻红登上音乐热榜', tag: '新', heat: 608, delta: '↑ 3600', up: true },
];

export const eventList: EventItem[] = [
  {
    id: 'e1',
    title: '综艺录制现场突发状况,导演组紧急回应',
    category: '影视综艺',
    categoryId: 'film',
    excerpt: '一段网传现场视频让围观群众瞬间炸锅,节目组随后发布说明澄清流程,评论区却吵成两派,吃瓜群众正火速赶往第一现场。',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20backstage%20variety%20show%20set%20with%20colorful%20stage%20lights%20and%20crew%20members%20in%20motion%2C%20stylized%20flat%20illustration%20with%20watermelon%20red%20and%20cream%20tones%2C%20dynamic%20crowd%20energy%2C%20playful%20editorial%20style%2C%20no%20text&width=800&height=500&seq=ev-film-01&orientation=landscape',
    views: '128万',
    comments: '8600',
    time: '28分钟前',
    heat: 96,
    trending: true,
  },
  {
    id: 'e2',
    title: '顶流主播凌晨开播回应,弹幕瞬间刷屏',
    category: '明星娱乐',
    categoryId: 'ent',
    excerpt: '前几日争议发酵后,主播选择深夜直播正面回应,百万人在线围观,连续三轮问答信息量巨大,围观群众直呼这一波瓜吃得很过瘾。',
    image: 'https://readdy.ai/api/search-image?query=stylized%20live%20streaming%20room%20scene%20with%20glowing%20monitor%20and%20comment%20wall%2C%20flat%20illustration%20watermelon%20red%20and%20soft%20cream%20palette%2C%20night%20vibe%20with%20warm%20accent%20glow%2C%20no%20text&width=800&height=500&seq=ev-ent-02&orientation=landscape',
    views: '203万',
    comments: '15200',
    time: '1小时前',
    heat: 99,
    trending: true,
  },
  {
    id: 'e3',
    title: '新剧预告一帧被扒,全网脑洞剧情走向',
    category: '影视综艺',
    categoryId: 'film',
    excerpt: '预告片中一闪而过的细节被火眼金睛的网友逐帧拆解,关于剧情走向的猜想多达数十种,相关话题阅读量两小时破亿。',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20preview%20poster%20style%20with%20dramatic%20figure%20silhouette%20and%20watermelon%20red%20and%20cream%20color%20field%2C%20stylized%20art%20poster%2C%20mysterious%20mood%2C%20modern%20graphic%20design%2C%20no%20text&width=800&height=500&seq=ev-film-03&orientation=landscape',
    views: '96万',
    comments: '7300',
    time: '2小时前',
    heat: 91,
    trending: true,
  },
  {
    id: 'e4',
    title: '科技公司发布会官宣新品,配置全面曝光',
    category: '科技圈',
    categoryId: 'tech',
    excerpt: '发布会直播中官宣的重磅新品引发数码圈集体沸腾,参数配置与价格一起冲上热搜,评论区正为"真香"还是"牙膏"争得不可开交。',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20tech%20product%20launch%20stage%20with%20floating%20device%20silhouette%2C%20stylized%20flat%20illustration%20in%20watermelon%20red%20and%20cream%20with%20fresh%20green%20accent%2C%20modern%20minimalist%20crowd%20scene%2C%20no%20text&width=800&height=500&seq=ev-tech-04&orientation=landscape',
    views: '175万',
    comments: '9800',
    time: '3小时前',
    heat: 94,
    trending: true,
  },
  {
    id: 'e5',
    title: '网友偶遇明星现身街角咖啡店,低调穿搭被夸',
    category: '明星娱乐',
    categoryId: 'ent',
    excerpt: '有网友晒出偶遇照片称明星独自买咖啡,生图状态与低调穿搭引发讨论,路人视角下的真实感让粉丝集体点赞。',
    image: 'https://readdy.ai/api/search-image?query=cozy%20corner%20cafe%20street%20scene%20with%20casual%20elegant%20figure%20at%20window%2C%20stylized%20flat%20illustration%20warm%20cream%20and%20watermelon%20red%20tones%2C%20everyday%20life%20vibe%2C%20soft%20morning%20light%2C%20no%20text&width=800&height=500&seq=ev-ent-05&orientation=landscape',
    views: '88万',
    comments: '6100',
    time: '5小时前',
    heat: 82,
    trending: false,
  },
  {
    id: 'e6',
    title: '品牌回应争议文案被指含糊,网友要求再回应',
    category: '商业财经',
    categoryId: 'business',
    excerpt: '针对连日来的质疑,品牌深夜发布长文回应,但部分网友认为回应避重就轻,评论区呈现明显两极,事态仍在持续发酵。',
    image: 'https://readdy.ai/api/search-image?query=modern%20brand%20corporate%20scene%20with%20abstract%20debate%20speech%20bubbles%20floating%2C%20stylized%20flat%20illustration%20watermelon%20red%20and%20cream%20tones%2C%20business%20mood%20with%20subtle%20green%20accent%2C%20no%20text&width=800&height=500&seq=ev-biz-06&orientation=landscape',
    views: '142万',
    comments: '12100',
    time: '6小时前',
    heat: 93,
    trending: true,
  },
  {
    id: 'e7',
    title: '决赛名场面刷屏,名宿赛后一番话再上热搜',
    category: '体坛赛事',
    categoryId: 'sports',
    excerpt: '决赛最后时刻的绝杀名场面让全网沸腾,赛后名宿的点评又添一把火,胜利方庆祝与失利方低落形成强烈对比。',
    image: 'https://readdy.ai/api/search-image?query=dynamic%20sports%20stadium%20final%20moment%20with%20silhouetted%20athletes%20and%20confetti%2C%20stylized%20flat%20illustration%20energetic%20watermelon%20red%20and%20cream%20palette%2C%20triumphant%20atmosphere%2C%20no%20text&width=800&height=500&seq=ev-sport-07&orientation=landscape',
    views: '234万',
    comments: '18700',
    time: '8小时前',
    heat: 98,
    trending: true,
  },
  {
    id: 'e8',
    title: '素人翻唱神曲一夜爆红,原唱暖心回应',
    category: '社会热点',
    categoryId: 'society',
    excerpt: '一段地铁偶遇素人演唱的视频意外出圈,低沉有故事感的嗓音征服无数网友,原唱本人也转发表达欣赏,双向奔赴的温情画面刷屏。',
    image: 'https://readdy.ai/api/search-image?query=subway%20station%20street%20musician%20singing%20with%20headphones%20crowd%20gathering%2C%20stylized%20flat%20illustration%20warm%20cream%20and%20watermelon%20red%20tones%2C%20heartwarming%20urban%20scene%2C%20no%20text&width=800&height=500&seq=ev-soc-08&orientation=landscape',
    views: '167万',
    comments: '9800',
    time: '9小时前',
    heat: 90,
    trending: true,
  },
  {
    id: 'e9',
    title: '朋友圈疯传的"养生冷知识",到底几个是真的?',
    category: '社会热点',
    categoryId: 'society',
    excerpt: '一篇打着专家旗号的养生文章在家族群里疯狂转发,里面关于日常习惯的说法真真假假,围观群众一边吃瓜一边喊"求辟谣"。',
    image: 'https://readdy.ai/api/search-image?query=colorful%20health%20and%20wellness%20flat%20illustration%20with%20fruits%20and%20question%20marks%2C%20watermelon%20red%20green%20and%20cream%20palette%2C%20playful%20lifestyle%20scene%2C%20informational%20mood%2C%20no%20text&width=800&height=500&seq=ev-soc-09&orientation=landscape',
    views: '79万',
    comments: '5300',
    time: '12小时前',
    heat: 74,
    trending: false,
  },
  {
    id: 'e10',
    title: '爆料帖引发站队大战,真相到底在哪边?',
    category: '明星娱乐',
    categoryId: 'ent',
    excerpt: '一封匿名爆料帖将许久平静的话题重新点燃,支持与反对的双方各执一词,围观群众表示:先别急着站队,让子弹再飞一会儿。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20online%20forum%20drama%20scene%20with%20two%20sides%20speech%20bubbles%20clashing%2C%20stylized%20flat%20illustration%20watermelon%20red%20and%20cream%2C%20intense%20debate%20energy%2C%20no%20text&width=800&height=500&seq=ev-ent-10&orientation=landscape',
    views: '156万',
    comments: '14300',
    time: '昨天',
    heat: 92,
    trending: true,
  },
  {
    id: 'e11',
    title: '发布会惊现"翻车名场面",主持人的神救场火了',
    category: '科技圈',
    categoryId: 'tech',
    excerpt: '发布会进行到一半现场设备意外故障,主持人几秒钟的临场反应堪称教科书级别,顺势抛出的段子让发布会意外出圈。',
    image: 'https://readdy.ai/api/search-image?query=stage%20presenter%20talking%20into%20microphone%20at%20modern%20launch%20event%2C%20stylized%20flat%20illustration%20cream%20and%20watermelon%20red%20tones%2C%20live%20stage%20ambience%2C%20no%20text&width=800&height=500&seq=ev-tech-11&orientation=landscape',
    views: '105万',
    comments: '7900',
    time: '昨天',
    heat: 85,
    trending: false,
  },
  {
    id: 'e12',
    title: '热播剧大结局前,编剧发文谈创作初衷',
    category: '影视综艺',
    categoryId: 'film',
    excerpt: '临近大结局,编剧一篇长文剖白创作背后的坚持与取舍,为追更的围观群众补上了满满的情绪价值,评论区一片动容。',
    image: 'https://readdy.ai/api/search-image?query=creative%20writer%20desk%20with%20screenplay%20pages%20and%20warm%20lamp%20light%2C%20stylized%20flat%20illustration%20cream%20watermelon%20red%20and%20soft%20green%20tones%2C%20contemplative%20storytelling%20mood%2C%20no%20text&width=800&height=500&seq=ev-film-12&orientation=landscape',
    views: '118万',
    comments: '9300',
    time: '昨天',
    heat: 87,
    trending: false,
  },
];

export const guideList: GuideItem[] = [
  { icon: 'ri-focus-3-fill', title: '如何快速看懂前因后果', desc: '先梳理时间线,再看原帖与回应,分清事实与观点,几分钟就能跟上完整节奏,不迷路。' },
  { icon: 'ri-finder-fill', title: '吃瓜不踩坑的搜索技巧', desc: '善用关键词与话题标签交叉搜索,配合时间筛选,帮你快速定位第一手现场与关键信息。' },
  { icon: 'ri-shield-check-fill', title: '先观望再下结论的理性吃瓜', desc: '面对大瓜先冷静,不轻信单方说辞,等待多方回应与实锤,做到理性围观不传谣。' },
  { icon: 'ri-chat-smile-fill', title: '友好讨论才是吃瓜的正确姿势', desc: '尊重当事人与不同观点,发言克制友善,和围观群众一起营造轻松、理性的讨论氛围。' },
];

export const faqList: FaqItem[] = [
  {
    q: '爆炸瓜是一个怎样的平台?',
    a: '爆炸瓜是面向吃瓜群众的在线吃瓜资讯门户,汇聚明星娱乐、社会热点、科技圈、影视综艺等热门事件的现场速递与热度排行,帮助大家轻松掌握最新动态、参与理性讨论。',
  },
  {
    q: '这里的"在线吃瓜"是什么意思?',
    a: '在线吃瓜指的是以轻松围观的心态,及时跟进正在发酵的热门事件与话题,了解前因后果并参与网友讨论。爆炸瓜为你汇总最受关注的现场,让你边吃边追、不掉队。',
  },
  {
    q: '内容多久更新一次?',
    a: '我们会持续跟进热门事件并滚动更新,实时热榜与现场速递板块会随着话题热度变化而刷新,让前排围观群众的体验始终跟得上节奏。',
  },
  {
    q: '我可以参与话题讨论吗?',
    a: '当然可以。每一条现场下方都欢迎围观群众发表看法,但请务必友善理性、尊重事实、不传播未经证实的信息,共同维护良好的讨论环境。',
  },
  {
    q: '如何反馈纠错或提供现场线索?',
    a: '如果你发现某条信息有误,或想分享值得关注的现场,可以通过页面底部的联系方式告诉我们,我们会第一时间核实处理。',
  },
];

export const reviewList: ReviewItem[] = [
  { name: '小瓜同学', role: '冲浪十级选手', avatar: 'https://readdy.ai/api/search-image?query=cute%20flat%20avatar%20of%20a%20happy%20young%20girl%20with%20watermelon%20slice%20motif%2C%20minimalist%20round%20icon%20style%2C%20watermelon%20red%20and%20cream%20palette&width=120&height=120&seq=av-01&orientation=squarish', text: '爆炸瓜的实时热榜真的很快,每次想吃瓜第一反应就是来这里,前排围观的感觉太爽了!' },
  { name: '铁瓜板凳', role: '吃瓜指南学员', avatar: 'https://readdy.ai/api/search-image?query=flat%20avatar%20of%20a%20cheerful%20young%20man%20wearing%20headphones%20eating%20watermelon%2C%20minimalist%20round%20icon%20style%2C%20watermelon%20red%20and%20cream%20palette&width=120&height=120&seq=av-02&orientation=squarish', text: '吃瓜指南里的理性吃瓜建议很受用,现在跟帖会先自己判断一下,再也不轻易被带节奏了。' },
  { name: '瓜田里的猹', role: '资讯重度用户', avatar: 'https://readdy.ai/api/search-image?query=flat%20avatar%20of%20a%20playful%20person%20holding%20a%20phone%20and%20smiling%2C%20minimalist%20round%20icon%20style%2C%20watermelon%20red%20green%20and%20cream%20palette&width=120&height=120&seq=av-03&orientation=squarish', text: '现场速递更新及时、归纳清晰,截图分享给朋友也方便,已经是每天必刷的站点之一了。' },
];